const getEnvironmentSuffix = () => {
  switch (process.env.BASE_URL) {
    case 'https://api-dev.anow.com':
      return '-dev';
    case 'https://api-staging.anow.com':
      return '-staging';
    case 'https://api.anow.com':
      return '';
    default:
      return '-dev';
  }
};

export default getEnvironmentSuffix;
